import type { ParameterDetail } from "@/types/line-editor.types";
import { ManualEntryField } from "./ManualEntryField";

interface Props {
  machineId: string;
  lineId: string;
  parameters: ParameterDetail[];
}

// Todo parâmetro MANUAL (≠ STATUS) gera campo de inserção.
// STATUS continua no StatusEntryBlock. Contadores de produção têm bloco
// próprio (ProductionEntryBlock); ficam de fora aqui p/ não duplicar a entrada.
export function ManualEntriesBlock({ machineId, lineId, parameters }: Props) {
  const manualParams = parameters.filter(
    (p) => p.source === "MANUAL" && p.category !== "STATUS" && p.productionRole !== "PRODUCES"
  );

  if (manualParams.length === 0) return null;

  return (
    <section>
      <h3 className="mb-2 text-xs uppercase tracking-wider text-muted-foreground">
        Registro manual
      </h3>
      <ul className="space-y-3 rounded-md border p-3">
        {manualParams.map((p) => (
          <li key={p.id}>
            <ManualEntryField parameter={p} machineId={machineId} lineId={lineId} />
          </li>
        ))}
      </ul>
    </section>
  );
}
